import React from 'react';
import type { IconComponentProps } from '@/types/components';

export const Advertisement: React.FC<IconComponentProps> = ({ className }) => (
  <svg
    className={className}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.6143 1.63119C13.7483 1.59211 13.8872 1.57227 14.0268 1.57227C14.8404 1.57227 15.5 2.23185 15.5 3.04548V11.8848C15.5 12.6984 14.8404 13.358 14.0268 13.358C13.8872 13.358 13.7483 13.3382 13.6143 13.2991L8.25751 11.7367C8.13122 13.2475 6.86492 14.4343 5.32143 14.4343C3.69416 14.4343 2.375 13.1152 2.375 11.4879V10.0209L1.65714 9.81155C0.971429 9.61155 0.5 8.98298 0.5 8.26869V6.66155C0.5 5.94726 0.971429 5.3187 1.65714 5.11869L13.6143 1.63119ZM3.98214 10.4897V11.4879C3.98214 12.2276 4.58176 12.8272 5.32143 12.8272C6.0611 12.8272 6.66071 12.2276 6.66071 11.4879V11.2709L3.98214 10.4897Z"
      fill="currentColor"
    />
  </svg>
);
